import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/api';
import toast from 'react-hot-toast';
import { Save } from 'lucide-react';

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.getSettings()
      .then(res => {
        // The endpoint returns an array for ViewSet list; take first or direct object
        const data = Array.isArray(res.data) ? res.data[0] : (res.data.results ? res.data.results[0] : res.data);
        setSettings(data || { vacation_requests_enabled: true, vacation_button_text: 'Solicitud de Vacaciones', welcome_message: '' });
      })
      .catch(() => {
        setSettings({ vacation_requests_enabled: true, vacation_button_text: 'Solicitud de Vacaciones', welcome_message: '' });
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await adminApi.updateSettings(settings);
      toast.success('Configuración guardada.');
    } catch { toast.error('Error al guardar.'); }
    setSaving(false);
  };

  if (loading || !settings) return <div className="spinner" />;

  return (
    <div>
      <div className="page-header">
        <h1>Configuración</h1>
        <p>Ajustes generales de la aplicación</p>
      </div>

      <div className="card" style={{ maxWidth: 600 }}>
        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={settings.vacation_requests_enabled}
              onChange={e => setSettings({ ...settings, vacation_requests_enabled: e.target.checked })}
              style={{ width: 18, height: 18 }}
            />
            <span style={{ fontSize: '1rem', fontWeight: 500 }}>
              Solicitudes de vacaciones activadas
            </span>
          </label>
          <p style={{ fontSize: '0.82rem', color: 'var(--gray-500)', marginTop: 4, marginLeft: 28 }}>
            Si se desactiva, el botón de vacaciones aparecerá deshabilitado para los empleados.
          </p>
        </div>

        <div className="form-group" style={{ marginTop: 24 }}>
          <label>Texto del botón de vacaciones</label>
          <input
            className="form-input"
            value={settings.vacation_button_text}
            onChange={e => setSettings({ ...settings, vacation_button_text: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Mensaje de bienvenida</label>
          <textarea
            className="form-input"
            value={settings.welcome_message}
            onChange={e => setSettings({ ...settings, welcome_message: e.target.value })}
            rows={3}
            placeholder="Bienvenido al Servicio de Atención al Empleado"
          />
        </div>

        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>
          <Save size={16} /> {saving ? 'Guardando...' : 'Guardar configuración'}
        </button>
      </div>
    </div>
  );
}
